<template>
  <div class="min-h-screen bg-gray-50 pb-28" dir="rtl">
    <BottomNav v-model="tab">
      <Chats />
    </BottomNav>
  </div>
</template>

<script>
  import Chats from '@/views/messenger/Chats.vue'
  import BottomNav from '@/components/BottomNav.vue'
  export default {
    data () {
      return {
        tab: null,
      }
    },
    components: {
      Chats,
      BottomNav
    }
  }
</script>
